import { GuideProgress } from './guide-progress.state';

export class SaveGuideProgress {
  static readonly type = '[Guide Progress] Save';
  constructor(public progress: GuideProgress) {}
}

export class ClearGuideProgress {
  static readonly type = '[Guide Progress] Clear';
}
